module.exports = __webpack_public_path__ + "static/media/feitian1.cd24e8ed.JPG";